<template>
  <div class="text-center my-5">
    <h1>This account is connected to external analytics</h1>
    <h3 class="mt-4"><i>{{url}}</i></h3>

    <div class="mt-5">
      <b-button
        variant="outline-primary"
        class="px-2 mr-1"
        @click="$emit('edit')">
        <i class="fa fa-pencil mr-2"/>
        Update
      </b-button>

      <b-button
        variant="outline-danger"
        class="px-2 mr-1"
        @click="$emit('delete')">
        <i class="fa fa-trash-o mr-2"/>
        Disconnect
      </b-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Connected',

    props: {
      url: String
    },
  };
</script>

<style scoped>

</style>
